import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { GetMyProfileResponse, UpdateMyPhoneNumbersRequest } from '../../types/auth.js'

import { apiClient } from '../../lib/client.js'
import { meKeys } from './keys.js'

export const useUpdateMyPhoneNumbersMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: UpdateMyPhoneNumbersRequest) => {
      const response = await apiClient.client.put<GetMyProfileResponse>('/me/phone-numbers', data)
      return response.data
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey: meKeys.profile })
    },
    onMutate: async (data) => {
      await queryClient.cancelQueries({ queryKey: meKeys.profile })

      const previousProfile = queryClient.getQueryData<GetMyProfileResponse>(meKeys.profile)

      if (previousProfile?.client) {
        queryClient.setQueryData<GetMyProfileResponse>(meKeys.profile, {
          ...previousProfile,
          client: {
            ...previousProfile.client,
            phoneNumbers: data.phoneNumbers.map((pn, index) => ({
              id: pn.id ?? `temp-${index}`,
              number: pn.number,
              type: pn.type,
            })),
          },
        })
      }

      return { previousProfile }
    },
  })
}
